export default __webpack_public_path__ + "static/media/logo.b9bbc23c.svg";